import React, { useCallback, useContext } from 'react';
import dynamic from 'next/dynamic';
import { Spinner } from '@/components/Atoms/Spinner/Spinner';
import { Dialog } from 'components/Atoms/Dialog/Dialog';
import { getDescopeConfig } from 'utils/descopeConfig';
import { PageContext } from 'src/context/PageContext';
import { determineCountryFromProps, determineRegionFromProps } from 'utils/determineRegionFromProps';
import { isMockResidentOrg } from '../useResidentSession';
import { MockSignIn } from './MockSignIn';
import styles from './LoginModal.module.scss';

const DescopeFlow = dynamic(() => import('../DescopeFlow/DescopeFlow').then((mod) => ({ default: mod.DescopeFlow })), {
  ssr: false,
  loading: () => <Spinner center />,
});

interface Props {
  open: boolean;
  setOpen: (open: boolean) => void;
  customerId?: string;
  onSuccess?: () => void;
}

export function LoginModal({ open, setOpen, customerId, onSuccess }: Props) {
  const { survey, questionnaire, organization, urlParams } = useContext(PageContext);
  const country = determineCountryFromProps({ organization, survey, questionnaire });
  const dataCenter = determineRegionFromProps(country);
  const handleSuccess = useCallback(
    (event: CustomEvent) => {
      // eslint-disable-next-line no-console
      console.log('[descope success]:', event);
      setOpen(false);
      onSuccess?.();
    },
    [setOpen, onSuccess],
  );

  const handleMockSuccess = useCallback(() => {
    setOpen(false);
    onSuccess?.();
  }, [setOpen, onSuccess]);

  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      classname={styles.modal}
      close
      noPadding
      content={
        isMockResidentOrg(urlParams?.organization) ? (
          <MockSignIn onSuccess={handleMockSuccess} />
        ) : (
          <DescopeFlow flowId={getDescopeConfig(dataCenter).flowId} customerId={customerId} onSuccess={handleSuccess} />
        )
      }
    />
  );
}
